
import SnippetForm from '@/components/snippets/Form.vue';
import Vue from 'vue';

Vue.component('snippet-form', SnippetForm);

export default Vue.extend({});
